(function () {
    var sectionSelector = '.npbp-bundle-text-popup';
    var stepSelector = '.npbp-bundle-text-popup__step';

    function setStepState(step, isOpen) {
        var trigger = step.querySelector('.npbp-bundle-text-popup__step-trigger');
        var panel = step.querySelector('.npbp-bundle-text-popup__step-panel');
        if (!trigger || !panel) {
            return;
        }
        step.classList.toggle('is-active', isOpen);
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        panel.classList.toggle('is-open', isOpen);
        panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    }

    function bindSection(section) {
        if (section.dataset.npbpTextPopupBound === 'true') {
            return;
        }
        section.dataset.npbpTextPopupBound = 'true';

        var isMobile = window.innerWidth <= 768;
        section.querySelectorAll(stepSelector).forEach(function (step) {
            var trigger = step.querySelector('.npbp-bundle-text-popup__step-trigger');
            var panel = step.querySelector('.npbp-bundle-text-popup__step-panel');
            if (!trigger || !panel || trigger.classList.contains('is-static')) {
                return;
            }
            if (isMobile) {
                setStepState(step, false);
            }
            trigger.addEventListener('click', function () {
                if (window.innerWidth > 768) {
                    return;
                }
                var shouldOpen = !step.classList.contains('is-active');
                section.querySelectorAll(stepSelector).forEach(function (item) {
                    setStepState(item, false);
                });
                if (shouldOpen) {
                    setStepState(step, true);
                }
            });
        });
    }

    function init(root) {
        var scope = root || document;
        var sections = scope.matches && scope.matches(sectionSelector)
            ? [scope]
            : scope.querySelectorAll(sectionSelector);
        sections.forEach(function (section) {
            bindSection(section);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        init(document);
    });
    document.addEventListener('shopify:section:load', function (event) {
        init(event.target);
    });
})();
